import React, { Component, PureComponent } from 'react'
import DataTable from '../datatable'
import Edit from './edit'

export let statusLabels = {
  pending: 'Odottaa käsittelyä',
  processing: 'Käsittelyssä',
  processed: 'Käsitelty',
}

const columns = [
  {
    name: 'name',
    label: 'Nimi',
    sortable: true,
    id: true,
  },
  {
    name: 'status',
    label: 'Status',
    sortable: true,
    options: statusLabels,
  },
  {
    name: 'type',
    label: 'Tyyppi',
    sortable: true,
    options: {
      new_project: 'Uusi projekti',
      additional: 'Lisätyö',
    },
  },
  {
    name: 'source',
    label: 'Lähde',
    sortable: true,
    options: {
      platform: 'Alusta',
      pipedrive: 'Pipedrive',
    },
  },
  {
    name: 'created_at',
    label: 'Luotu',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
    defaultSort: true,
  },
]

export default function OrderRoot() {
  return (
    <DataTable
      id="orders"
      entity="order"
      crud
      title="Tilaukset"
      sortDir="desc"
      editComponent={Edit}
      texts={{ createButton: 'Lisää tilaus' }}
      columns={columns}
    />
  )
}
